// extracted by mini-css-extract-plugin
module.exports = {"root":"checkbox_root__1xuyd","checkbox":"checkbox_checkbox__k9vCf","checkmark":"checkbox_checkmark__7lkOe"};